export default {"src":"/_next/static/media/LTOClockHands.c95b98b9.svg","height":10,"width":7,"blurWidth":0,"blurHeight":0};